import { Component, Input, OnInit } from "@angular/core";
import { AlertController, ModalController, NavController, ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { take } from "rxjs";
import { IDatePlace } from "src/app/models/location.model";
import { NotificationBacklog } from "src/app/models/notification.model";
import { OrderModel } from "src/app/models/order.model";
import { ProfileModel } from "src/app/models/profile.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ContextService } from "src/app/services/context/context.service";
import { DataService } from "src/app/services/data/data.service";
import { DateService } from "src/app/services/date/date.service";
import { ExcelService } from "src/app/services/excel/excel.service";
import { ExternalService } from "src/app/services/external/external.service";
import { MathService } from "src/app/services/math/math.service";
import { OrderService } from "src/app/services/order/order.service";
import { PdfService } from "src/app/services/pdf/pdf.service";
import { SaleService } from "src/app/services/sale/sale.service";
import { ShareService } from "src/app/services/share/share.service";
import { MessageComposerComponent } from "../message/message-composer.component";
import { RecurrenceEditComponent } from "../recurrence-edit/recurrence-edit.component";
import { ShareComponent } from "../share/share.component";

@Component({
  selector: "sale-header",
  templateUrl: "./sale-header.component.html",
  styleUrls: ["./sale-header.component.scss"]
})
export class SaleHeaderComponent implements OnInit {
  _tournee:TourneeModel;

  @Input('tournee')
  set tournee(value:TourneeModel){
    this._tournee = value;
    this.setCanEdit();
  }

  orderCount = 0;

  @Input()
  menuBar: string;

  @Input()
  dates: IDatePlace[];

  @Input()
  orders: OrderModel[];

  @Input()
  mode: string;

  printing = false;
  canEdit = false;
  canApply = false;
  // showModal = false;

  selectedDate:any;

  modal:HTMLIonModalElement
  preparationDisplayed = false;

  @Input()
  viewer: ProfileModel;

  constructor(public dateService: DateService, public mathService: MathService, 
    public contextService: ContextService, public saleService:SaleService,
    private navCtrl:NavController, private dataService: DataService,
    private translateService: TranslateService, private pdfService:PdfService,
    private excelService: ExcelService, private alertCtrl: AlertController,
    private shareService: ShareService, private modalCtrl: ModalController,
    private toastCtrl: ToastController, private auth:AuthenticationService,
    private orderService: OrderService, public externalService: ExternalService) {
    }

  ngOnInit() {}

  ngOnDestroy() {}

  async setCanEdit(){
    // console.log(this._tournee);
    const user = await this.auth.getUser();
    if(user && this._tournee.producer){
      if(user.uid==this._tournee.producer.key || user.role =='admin'){
        this.canEdit = true;
      }
      else if(user.uid){
        this.dataService.getMyProducer(this._tournee.producer.key,user.uid).pipe(take(1)).subscribe(result=>{
          if(result && result.role == 'owner'){
            this.canEdit = true;
          }
          else if(user.role == 'producer'){
            this.canApply = true;
          }
        })
      }
    }
  }

  public showPreparation(): void {
    this.preparationDisplayed = true;
  }
  public hidePreparation(): void {
    this.preparationDisplayed = false;
  }
  public backToMarketPage(): void {
    this.navCtrl.navigateForward("market/" + this._tournee.market.key);
  }

  public goHome(): void {
    this.navCtrl.navigateBack("/producer/" + this._tournee.producer.key);
  }

  async tab() {
    await this.dataService.setUserConfig(this._tournee.producer.key,"manageTourneeView","tabs");
    this.navCtrl.navigateForward("/producer/" + this._tournee.producer.key + "/sale/" + this._tournee.key+"/tabs/orders");
  }

  public copy(): void {
    this.navCtrl.navigateForward("/producer/" + this._tournee.producer.key + "/sale/" + this._tournee.key+"/copy");
  }

  public viewMap(): void {
    this.navCtrl.navigateForward("/producer/" + this._tournee.producer.key + "/sale/" + this._tournee.key + "/map");
  }
  public edit(): void {
    this.navCtrl.navigateForward("/producer/" + this._tournee.producer.key + "/sale/" + this._tournee.key + "/edit");
  }

  public markTourneeFull(): void {
    this.changeStatus("full");
  }

  async export(): Promise<void> {
    this.dataService.getProducerTourneeProductsOrdered(this._tournee.producer.key, this._tournee.key).pipe(take(1)).subscribe(async result=>{
      if(result){
        for(const order of result){
          if(!this._tournee.orders[order.key]){
            console.log('missing order', order.key);
          }
          else if(order.products){
            this._tournee.orders[order.key].products = order.products;
          }
        }
      }
      const filename =
      this.translateService.instant("order.orders") +
      "-" +
      this._tournee.details.name +
      "-" +
      new Date(this._tournee.details.date).toLocaleDateString();
      const orders = this.orderService.sortAndTransformToArray(this._tournee);
      console.log(this._tournee, orders);
      const alert = await this.alertCtrl.create({
        header: this.translateService.instant("export.ExportType"),
        message: this.translateService.instant("export.ExportTypeSubtitle"),
        backdropDismiss: true,
        buttons: [
          {
            role: "table",
            text: this.translateService.instant("export.Table"),
            handler: () => {
              this.excelService.exportOrders(orders, filename);
            }
          },
          {
            role: "pdf",
            text: this.translateService.instant("export.PDF"),
            handler: () => {
              this.exportAsPDFFile(filename);
            }
          }
        ]
    });
    await alert.present();
    await alert.onDidDismiss();
    });  
  }

  async exportAsPDFFile(filename:string): Promise<void> {
    const buttons = [];

    for(const datePlace of this._tournee.details.datesPlaces){
      buttons.push({
        text: this.dateService.formatDatePlace(datePlace,true,false, true),
        handler: () => {
          this.pdfService.exportTourneeOrderToPdf(this._tournee,datePlace, filename);
        }
      })
    }
    const alert = await this.alertCtrl.create({
      header: this.translateService.instant("export.Export") + " " + this.translateService.instant("export.PDF"),
      message: this.translateService.instant("export.WhatDatePlace"),
      backdropDismiss: true,
      buttons: buttons
    });
    await alert.present();
    await alert.onDidDismiss();
  }

  async cancelTournee(): Promise<void> {
    if(this._tournee.status == 'open' || this._tournee.status == 'draft'){
      const alert = await this.alertCtrl.create({
        header: this.translateService.instant("tournee.cancel.Title"),
        message: this.translateService.instant("tournee.cancel.Subtitle"),
        backdropDismiss: true,
        buttons: [
          {
            role: "back",
            text: this.translateService.instant("buttons.Back")
          },
          {
            role: "cancel",
            text: this.translateService.instant("buttons.Cancel"),
            handler: () => {
              this.changeStatus("cancelled");
              this.presentToast(this.translateService.instant("tournee.cancel.Confirmed"));
            }
          },
          {
            role: "delete",
            text: this.translateService.instant("buttons.Delete"),
            handler: async () => {
              await this.deleteTournee();
              this.goHome();
            }
          }
        ]
      });
      await alert.present();
      await alert.onDidDismiss();
    }
    else{
      await this.deleteTournee();
      this.goHome();
    }
  }

  async apply(): Promise<void> {
    if(this._tournee.status == 'open' || this._tournee.status == 'draft'){
      const alert = await this.alertCtrl.create({
        header: this.translateService.instant("tournee.cancel.Title"),
        message: this.translateService.instant("tournee.cancel.Subtitle"),
        backdropDismiss: true,
        buttons: [
          {
            role: "back",
            text: this.translateService.instant("buttons.Back")
          },
          {
            role: "cancel",
            text: this.translateService.instant("buttons.Cancel"),
            handler: () => {
              this.changeStatus("cancelled");
              this.presentToast(this.translateService.instant("tournee.cancel.Confirmed"));
            }
          },
          {
            role: "delete",
            text: this.translateService.instant("buttons.Delete"),
            handler: async () => {
              await this.deleteTournee();
              this.goHome();
            }
          }
        ]
      });
      await alert.present();
      await alert.onDidDismiss();
    }
    else{
      await this.deleteTournee();
      this.goHome();
    }
  }

  transformIntoMarket(){
    this.dataService.transformIntoMarket(this._tournee);
  }

  async notifyCustomersSaleIsOpened(){
    const alert = await this.alertCtrl.create({
      header: this.translateService.instant("message.Notify"),
      message: this.translateService.instant("tournee.NotifyCustomersSaleIsOpened"),
      backdropDismiss: true,
      buttons: [
        {
          role: "cancel",
          text: this.translateService.instant("buttons.Cancel"),
          handler: () => {
            
          }
        },
        {
          role: "notify",
          text: this.translateService.instant("message.Notify"),
          handler: async () => {
            const notification: NotificationBacklog = {
              itemKey: this._tournee.key,
              producerKey: this._tournee.producer?.key ?? this._tournee.owner.key,
              dateTime: new Date().toISOString(),
              type: 'sale'
            };
            console.log(notification);
            await this.dataService.createNotification(notification);
            await this.presentToast(this.translateService.instant("tournee.NotificationPlanned"));
            alert.dismiss();
          }
        }
      ]
    });
    await alert.present();
    await alert.onDidDismiss();
  }

  async presentToast(message: string): Promise<void> {
    const toast = await this.toastCtrl.create({
      message,
      duration: 15000,
      buttons: [
        {
          side: "end",
          icon: "close-circle-outline",
          role: "cancel",
          handler: () => {
            console.log("dismiss toast");
            // toast.dismiss();
          }
        }
      ],
      position: "middle"
    });
    toast.present();
  }

  async shareTournee(): Promise<void> {
    this.modal = await this.modalCtrl.create({
      component: ShareComponent,
      cssClass: "small-modal",
      componentProps: {
        tournee: this._tournee,
        onShared: () => {
          this.modal.dismiss();
        },
      }
    });
    return await this.modal.present();
  }

  async sendMessage(){
    this.modal = await this.modalCtrl.create({
      component: MessageComposerComponent,
      cssClass: "shopping-cart",
      componentProps: {
        itemKey: this._tournee.key,
        sender: this._tournee.producer || this._tournee.owner,
        type: this._tournee.details.format=='group'?'market':'sale' ,
        onCancel: () => {
          this.modal.dismiss();
        },
        onMessageSent: () => {
          this.modal.dismiss();
        },
      }
    });
    return await this.modal.present();
  }

  printPoster(): void {
    this.createPdf(this._tournee);
  }


  async createPdf(tournee: TourneeModel): Promise<void> {
    this.printing = true;
    await this.pdfService.createSalePdf(tournee);
    this.printing = false;
  }

  async editRecurrence(): Promise<void>{
    this.modal = await this.modalCtrl.create({
      component: RecurrenceEditComponent,
      cssClass: "modal",
      componentProps: {
        tournee: this._tournee,
        onCancel: () => {
          this.modal.dismiss();
        },
        onChange: () => {
          this.modal.dismiss();
        }
      }
    });
    return await this.modal.present();
  }


  private deleteTournee():Promise<void>{
    return this.dataService.deleteTournee(this._tournee);
  }

  public markTourneeOpen(): void {
    this.changeStatus("open");
  }

  public markTourneePrepared(): void {
    this.changeStatus("prepared");
  }

  async makePublic(){
    const result = await this.dataService.makeSalePublic(this._tournee.key, this._tournee.producer.key);
    console.log(result);
  }

  public markTourneeDelivered(): void {
    this.changeStatus("delivered");
  }
  public changeStatus(status: string): void {
    this._tournee.status = status;
    this.dataService.updateTourneeStatus(this._tournee);
  }

  public resume() {
    //
  }
}
